module.exports = __webpack_public_path__ + "static/img/zongjingli.0f567bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zongjingli.jpg
// module id = sefn
// module chunks = 1